import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { AppRetailerBlock } from "@components/DataBlocks"
import { BACKEND_APIS } from "@constants"


export default function AppSitesAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		label="Sites"
		placeholder="All Sites"
		formatOptionLabel={({ label, market }) => <AppRetailerBlock retailer={label} country={market} />}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/site`}
		{...props}
	/>
}